import { render, staticRenderFns } from "./WinerySocialMedia.vue?vue&type=template&id=8ba30170&"
import script from "./WinerySocialMedia.vue?vue&type=script&lang=js&"
export * from "./WinerySocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports